/**
 * Định nghĩa các cột fix cứng dùng chung trên chương trình
 */
export default {
  amountOc: 'amount_oc',
  amount: 'amount',
  debitAccount: 'debit_account',
  creditAccount: 'credit_account',
  taxAccount: 'tax_account', // Tài khoản thuế
  cogsAccount: 'cogs_account', // Tài khoản giá vốn
  inventoryAccount: 'inventory_account', // Tài khoản kho
  budgetSourceId: 'budget_source_id',
  cashWithdrawTypeId: 'cash_withdraw_type_id',
  methodDistributeId: 'method_distribute_id',
  methodDistributeName: 'method_distribute_name',
  orgRefDetailId: 'org_ref_detail_id', // Thông tin trường đánh dấu chứng từ detail gốc sinh ra dòng hạch toán
  refDetailId: 'ref_detail_id', // Thông tin trường là khóa chi tiết chứng từ map với orgRefDetailId ở trên
  sign: 'sign', // Trường ghi chú trong quy tắc hạch toán đồng thời chi tiết (Ghi âm, ghi dương)
  fundStructureCode: 'fund_structure_code', // Trường nội dung chi phí trong Hủy dự toán

  // Các cột bổ sung check thêm để show cảnh báo rule hạch toán đồng thời không phù hợp với quy tắc
  budgetChapterCode: 'budget_chapter_code',
  budgetSubKindItemCode: 'budget_sub_kind_item_code',
  budgetItemCode: 'budget_item_code',
  budgetExpenseGroupItemCode: 'budget_expense_group_item_code',
  budgetProvideCode: 'budget_provide_code',
  budgetSubItemCode: 'budget_sub_item_code',
  budgetDetailItemCode: 'budget_detail_item_code',
  projectCode: 'project_code',
  topicCode: 'topic_code',
  budgetFeesCode: 'budget_fees_code',
  // Cột parent id
  parentId: 'parent_id',
  refId: 'ref_id',
  refNo: 'ref_no',
  refDate: 'ref_date',
  refType: 'ref_type',
  isPosted: 'is_posted',
  postedDate: 'posted_date', // Ngày hạch toán (nvthinh 1.4.2024)

  budget_chapter_id: 'budget_chapter_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_chapter_name: 'budget_chapter_name',

  budgetKindItemCode: 'budget_kind_item_code',
  budgetSourceName: 'budget_source_name',
  budgetItemDetailCode: 'budget_item_detail_code',
};
